@if ((vm$ | async)?.overlayVisible) {
  <dff-cookie-consent-overlay>
    <slot></slot>
  </dff-cookie-consent-overlay>
}
